module.exports = __webpack_public_path__ + "static/img/calioh-coffee.22a32ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/calioh-coffee.png
// module id = gmHy
// module chunks = 0